export default __webpack_public_path__ + "static/media/Zahl-5.2ec9a62b.webp";